import { render, staticRenderFns } from "./index.vue?vue&type=template&id=796ed3db&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./styles/index.scss?vue&type=style&index=0&id=796ed3db&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "796ed3db",
  null
  
)

export default component.exports